const StatusBadge = ({ active, label }) => (
  <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-700'}`}>
    {label}
  </span>
)

export default StatusBadge
